module.exports = __webpack_public_path__ + "images/pages/lp/kaitori_image_25060dba00d38b2c1edc4ba0d8874980.png";